import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import Row from "./Row";
import { TransactionDetails } from "../../../types";
import ActionButton from "../../ActionButton";
import CardText from "../../CardText";
import { PaymentMethod } from "../../PaymentMethod";
import TransactionQRModal from "../TransactionQRModal";

type Props = {
  paymentInfo?: TransactionDetails["payment"]["paymentInfo"];
  action: TransactionDetails["payment"]["availableActions"]["resendPaymentRequestUrl"];
};

export default function PaymentInfo({ paymentInfo, action }: Props) {
  const tailwind = useTailwind();

  return (
    <Row style={tailwind("mt-4 items-center")}>
      {paymentInfo ? (
        <>
          <CardText.Body
            text={paymentInfo.consumerName}
            style={tailwind("flex-1")}
          />
          <PaymentMethod paymentMethod={paymentInfo.paymentMethod} showText />
        </>
      ) : (
        <>
          <View style={tailwind("flex-1")}>
            <CardText.Body text="Tu cliente no ha pagado aún." error />
          </View>

          <TransactionQRModal url={action.params.url} />

          <ActionButton action={action} />
        </>
      )}
    </Row>
  );
}
